<script>
  export let use_nav = true, home_link = true, user = false
  export let links = [], hStyle = 'bg-gradient-to-b from-powder to-transparent', is_active = 'top', aStyle = 'cursor-pointer hover:text-poppy focus:text-poppy'
  import { createEventDispatcher } from 'svelte'
  import Logo from './partials/Logo.svelte'

  const section = createEventDispatcher()
  
  function easeOutCubic(currentIteration, startValue, changeInValue, totalIterations) {
      return changeInValue * (Math.pow(currentIteration / totalIterations - 1, 3) + 1) + startValue;
  }
  
  function switchSection(event) {
    event.preventDefault()
    is_active = event.target.dataset.section

    let scrollContainer = document.querySelector('[data-container]')
    let item = document.getElementById(is_active)
    let currentIteration = 0;
    let animIterations = Math.round(60 * 0.5); 

    scrollContainer.style.scrollSnapType = 'unset'

    let from = scrollContainer.scrollTop;
    let by = item.offsetTop - scrollContainer.scrollTop;
    if (from < item.offsetTop) {
      if (item.offsetTop > scrollContainer.scrollHeight - scrollContainer.clientHeight) {
        by = (scrollContainer.scrollHeight - scrollContainer.clientHeight) - scrollContainer.scrollTop;
      }
    }

    (function scroll() {
      let value = easeOutCubic(currentIteration, from, by, animIterations);
      scrollContainer.scrollTop = value;
      currentIteration++;
      if (currentIteration < animIterations) {
        requestAnimationFrame(scroll);
      }else{
        scrollContainer.removeAttribute('style')
      }
    })()

    section('message', {
      text: is_active
    })
  }
</script>
<header class="fixed top-0 left-0 w-screen px-4 sm:px-6 lg:px-12 py-2 lg:py-8 z-40 {hStyle}">
  <div class="flex flex-row items-center container text-white">
    {#if use_nav}
    <a on:click={switchSection} data-section="top" href="#top" aria-label="Pangea"
     class="transition ease-out block mr-10 md:mr-20 ml-0 w-10 h-10 sm:w-16 sm:h-16 flex justify-center items-center {( is_active === 'top' || is_active === '' || home_link === false) ? 'pointer-events-none' : aStyle}">
      <Logo/>
    </a>
    <nav class="hidden sm:flex">
      {#if links}
        {#each links as link (link.id)}
          {#if link.is_anchor}
          <a href="{link.href}"
           class="transition ease-out font-display py-3 mx-2 sm:mx-6 sm:py-0 {is_active === link.href ? 'text-poppy' : aStyle}"
          >{link.slug}</a>
          {:else}
        <a href="#{link.href}" data-section={link.href}
         class="transition ease-out font-display py-3 mx-2 sm:mx-6 sm:py-0 {is_active === link.href ? 'text-poppy' : aStyle}"
         on:click={switchSection}>{link.slug}</a>
          {/if}
        {/each}
      {/if}
    </nav>
      {#if user}
        {#if user.user_level_id === 3}
    <a href="/logout" class="absolute right-8 text-xs uppercase" title="Logout">Logout</a>
        {/if}
      {/if}
    {:else}
    <div class="text-white w-16 h-16 sm:w-20 sm:h-20">
      <Logo/>
    </div>
    {/if}
  </div>
</header>